import { useContext, useEffect, useState } from 'react';
import moment from 'moment/moment';
import { CreateBookingFormContext } from '../CreateBookingForm.context';

const useSubHeaderHook = () => {
  const dateFormat = 'DD/MM/YYYY';
  const { formState } = useContext(CreateBookingFormContext);
  const [state, setState] = useState({ startDate: null, endDate: null, rooms: null });

  useEffect(() => {
    actions.initialize();
  }, [, formState]);

  const actions = {
    initialize: () => {
      const { bookingDates, roomsDetails } = formState;
      let startDate, endDate;
      if (bookingDates?.startDate) {
        startDate = moment(bookingDates.startDate).format(dateFormat);
      }
      if (bookingDates?.endDate) {
        endDate = moment(bookingDates.endDate).format(dateFormat);
      }
      updateState({ rooms: roomsDetails, startDate, endDate });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useSubHeaderHook;
